module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"selfie":"Selfie","id scan":"ID Scan","assessment":"Assessment"},"es":{"selfie":"Autofoto","id scan":"Identificación","assessment":"Evaluación"},"sw":{"selfie":"Selfie","id scan":"Utambulisho","assessment":"Tathmini"}}')
  delete Component.options._Ctor
}
